import { render } from '@wordpress/element';

/**
 * Import the stylesheet for the plugin.
 */
import './style/main.scss';
import Dashboard from "./Dashboard";
import AiDashboard from './components/ai-dashboard/AiDashboard';
import SeoDashboard from './components/seo-dashboard/SeoDashboard';

// Find the target DOM element based on its ID
const dashboardElement = document.getElementById('admin-dashboard');

// Check if the elements exist and render the corresponding component
if (dashboardElement) {
  render(<Dashboard />, dashboardElement);
}

const AiDashboardElement = document.getElementById('ai-dashboard');

if (AiDashboardElement) {
  render(<AiDashboard />, AiDashboardElement);
}

const SeoDashboardElement = document.getElementById('seo-dashboard');

if (SeoDashboardElement) {
  render(<SeoDashboard />, SeoDashboardElement);
}